var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323",
    transform: "translate(21526 -11475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    transform: "translate(-21526 11475)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 69,
    r: 69,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 69,
    r: 68.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-21486 11515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M53.9,38.528a33.453,33.453,0,0,1-10.5-1.669,4.5,4.5,0,0,0-4.567.967L32.19,42.843A37.106,37.106,0,0,1,15.676,26.332l4.881-6.486A4.661,4.661,0,0,0,21.7,15.134,33.44,33.44,0,0,1,20.018,4.62,4.625,4.625,0,0,0,15.4,0H4.62A4.625,4.625,0,0,0,0,4.62a53.959,53.959,0,0,0,53.9,53.9,4.625,4.625,0,0,0,4.62-4.62V43.147A4.625,4.625,0,0,0,53.9,38.528Z",
    transform: "translate(0)",
    fill: "#ed193a"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallicon);
export default __webpack_public_path__ + "static/media/Call icon.4530ee36ad7057ddaed0eac3245b04d3.svg";
export { ForwardRef as ReactComponent };